// src/features/search/SearchResultsList.jsx
import { useSearchParams ,Link} from "react-router-dom";
import { useEffect, useState } from "react";

import { MAX_RESULTS_PER_PAGE } from "../../services/lib/constants.js";
import PreviewImage from "../../component/previews/PreviewImage.js";

import Heading from "../ui/Heading.js";
import Loader from "../ui/Loader.js";
import Separator from "../ui/Separator.js";
import PaginationNav from "../PaginationNav/PaginationNav.js";
import ResultsTwoColumns from "./ResultsTwoColumns.js";
import SearchNoResults from "./SearchNoResults.js";

import { useSearchVideosMutation } from '../../services/modulesuser/videoListApi';

export default function SearchResultsList({ query }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page")) || 1;

  // Mutation RTK
  const [searchVideos, { isLoading, data, error }] = useSearchVideosMutation();

  // trigger la ricerca quando cambiano query o page
  useEffect(() => {
    if (query && query.length > 2) {
      searchVideos({ title: query, page });
    }
  }, [query, page, searchVideos]);

  const [searchHistory, setSearchHistory] = useState([]);
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("searchHistory") || "[]");
    setSearchHistory(stored);
  }, []);

  const setQuery = (q) => {
    setSearchParams({ q, page: "1" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const clearQuery = () => {
    setSearchParams({ q: "", page: "1" });
  };

  if (isLoading) return <Loader />;
  if (error || !data)
    return (
      <div className="text-red-500">
        {error?.message || "Error fetching data"}
      </div>
    );

  const results = data.results ?? [];
  const totalPages = Math.ceil(
    (data.total_results ?? 0) / MAX_RESULTS_PER_PAGE
  );
 console.log(results);
  return (
    <section>
      <Heading>Risultati Ricerca</Heading>

      {query.length > 2 && results.length > 0 ? (
        <>
          <h4 className="text-[2rem] sm:text-[2.2rem]">
            Mostra risultati: <em>"{query}"</em>
          </h4>
          <p className="text-2xl mt-2">
            Pagina {page} • Totale resultati: {data.total_results}
          </p>

          <Separator className="my-10" />
          {/* <ResultsTwoColumns media={results} /> */}
          <div className="flex flex-wrap gap-6 justify-start content-start">
          {results.map((video) => (
            <div
              key={video.videoId}
              style={{ flexBasis: 300 }}
              className="block flex-shrink-0 rounded-lg overflow-x-hidden max-w-[350px] w-full"
            >
              <Link
                to={`/videos/${video.id}`}
                state={{ video: video }}
                className="block"
                style={{ height: 200 }}
              >
                <PreviewImage media={video} type={'tv'} hud={true} />
              </Link>
            </div>
          ))}
        </div>
          <Separator className="my-10" />
          <PaginationNav
            page={page}
            totalPages={totalPages}
            handlePageChange={(newPage) => {
              setQuery(query);
              setSearchParams({
                q: query,
                page: newPage.toString(),
              });
            }}
          />
        </>
      ) : (
        <SearchNoResults query={query} />
      )}
    </section>
  );
}
